import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '_helpers';

const name = 'emails';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports
export const emailsActions = { ...slice.actions, ...extraActions };
export const emailsReducer = slice.reducer;

// implementation
function createInitialState() {
    return {
        list: null,
        isLoading: false,
        error: null,
    };
}

function createExtraActions() {
    const baseUrl = process.env.REACT_APP_API_URL;

    return {
        getAll: getAll(),
    };

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async () => await fetchWrapper.get(`${baseUrl}/mails`)
        );
    }
}

function createExtraReducers() {
    return (builder) => {
        getAll();

        function getAll() {
            var { pending, fulfilled, rejected } = extraActions.getAll;
            builder
                .addCase(pending, (state) => {
                    state.isLoading = true;
                })
                .addCase(fulfilled, (state, action) => {
                    state.isLoading = false;
                    state.list = action.payload;
                })
                .addCase(rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.error.message || 'Echec de récupération des pré-alertes';
                });
        }
    };
}

export default emailsReducer;

